import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import ButtonIconSquare from '../buttons/icon-square/button-icon-square'
import IconCheck from 'assets/images/icons/check.svg'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'unset',
  },
  title: {
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.smedium,
  },
  button: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    marginTop: 15,
  },
  fullscreen: {
    height: `calc(100vh - ${theme.menuHeight}px)`,
    padding: '0px 20vw 0px 20vw',
  },
}))

const UnlockView = (props) => {
  const { title, description, onUpgradeClick, fullscreen = true, classes: externalClasses = {} } = props
  const classes = useStyles({ fullscreen })

  const containerClass = clsx(classes.container, fullscreen && classes.fullscreen, externalClasses.container)
  return (
    <div className={containerClass}>
      {fullscreen ? <span className={clsx(classes.title, externalClasses.title)}>{title}</span> : null}
      <p className={clsx(classes.description, externalClasses.description)}>{description}</p>
      <div className={clsx(classes.button, externalClasses.button)}>
        <ButtonIconSquare label={lang.planUpgradeButton} icon={IconCheck} onClick={onUpgradeClick} />
      </div>
    </div>
  )
}

UnlockView.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onUpgradeClick: PropTypes.func,
  fullscreen: PropTypes.bool,
  classes: PropTypes.shape({
    container: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    button: PropTypes.string,
  }),
}

export default UnlockView
